var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Fornecedor_ClienteActions } from "@/store/enums/FornecEnums";
import { Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Fornecedor_ClienteModule = class Fornecedor_ClienteModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Fornecedor_ClienteActions.POST_FORNECEDOR_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.post("Fornecedor_Cliente/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Fornecedor_ClienteActions.POSTBACK_FORNECEDOR_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.post("Fornecedor_Cliente/PostBack", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Fornecedor_ClienteActions.PUT_FORNECEDOR_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.put("Fornecedor_Cliente/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Fornecedor_ClienteActions.DELETE_FORNECEDOR_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.delete("Fornecedor_Cliente/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Fornecedor_ClienteActions.DELETE_RANGE_FORNECEDOR_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.delete("Fornecedor_Cliente/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Fornecedor_ClienteActions.FILTER_FORNECEDOR_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.post("Fornecedor_Cliente/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Fornecedor_ClienteActions.GET_FORNECEDOR_CLIENTE]() {
        return new Promise(resolve => {
            fornecService.get("Fornecedor_Cliente/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Fornecedor_ClienteActions.GETWITHDISABLED_FORNECEDOR_CLIENTE]() {
        return new Promise(resolve => {
            fornecService.get("Fornecedor_Cliente/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Fornecedor_ClienteActions.GET_BY_ID_FORNECEDOR_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.get("Fornecedor_Cliente/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fornecedor_ClienteModule.prototype, _j, null);
Fornecedor_ClienteModule = __decorate([
    Module
], Fornecedor_ClienteModule);
export default Fornecedor_ClienteModule;
//# sourceMappingURL=Fornecedor_ClienteModule.js.map